import { render } from "./TodayJobs.vue?vue&type=template&id=0c340d3e"
import script from "./TodayJobs.vue?vue&type=script&lang=js"
export * from "./TodayJobs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__